import * as React from 'react'
import { DisplayContent, Plural, Singular } from 'react-content-engine'
import { connect } from 'react-redux'

import { ListItem } from 'components/List'
import { AppState } from '../../../data/state'

interface NrPeopleSummaryProps {
  nrAdults: number
  nrKids: number
  nrBabies: number
}

const NrPeopleSummary: React.FC<NrPeopleSummaryProps> = ({
  nrAdults,
  nrKids,
  nrBabies,
}) => {
  return (
    <ListItem>
      <DisplayContent
        contentKey="travelers-summary-aduls"
        vars={{ adults: nrAdults.toString() }}
        plural={nrAdults > 1}
      >
        <Singular>{`${nrAdults} adult`}</Singular>
        <Plural>{`${nrAdults} adults`}</Plural>
      </DisplayContent>

      {nrKids > 0 ? (
        <DisplayContent
          contentKey="travelers-summary-children"
          vars={{ children: nrKids.toString() }}
          plural={nrKids > 1}
        >
          <Singular>{`, ${nrKids} child`}</Singular>
          <Plural>{`, ${nrKids} children`}</Plural>
        </DisplayContent>
      ) : null}

      {nrBabies > 0 ? (
        <DisplayContent
          contentKey="travelers-summary-babies"
          vars={{ babies: nrBabies.toString() }}
          plural={nrBabies > 1}
        >
          <Singular>{`, ${nrBabies} baby`}</Singular>
          <Plural>{`, ${nrBabies} babies`}</Plural>
        </DisplayContent>
      ) : null}
    </ListItem>
  )
}

export default connect((state: AppState) => ({
  nrAdults: state.funnelOrder.numberOfAdults,
  nrKids: state.funnelOrder.numberOfChildren,
  nrBabies: state.funnelOrder.numberOfBabies,
}))(NrPeopleSummary)
